export enum ButtonAppearance {
  ALFA = 'ALFA',
  BRAVO = 'BRAVO',
  CHARLIE = 'CHARLIE',
}
